<template>
    <div class="loading-wrapper">
        <div class="loading-spinner">
            <svg class="spinner" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g v-html="getIconPath(iconNames.spinner)"/>
            </svg>
        </div>
        <span class="state-text">{{ displayText }}</span>
    </div>

</template>

<script setup>
import { getIconPath, iconNames } from '@/Modules/utils/icons';

defineProps({
    displayText: {
        type: String,
        required: true
    }
})

</script>

<style scoped>
.loading-wrapper {
    color: var(--highlights);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.loading-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
}

.spinner {
    animation: spin 1s linear infinite;
    color: var(--highlights);
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>
